import React from 'react';
import propType from 'prop-types';
import HelmetComponent from '../../components/Helmet';
import NavigationHeader from '../../components/HeaderNavigation';
import Banner from './components/Banner';
import NewsGrid from './components/NewsGrid';
import Footer from './components/Footer';
import Breadcrumb from './components/Breadcrumb';

function News({ data }) {
  return (
    <>
      <HelmetComponent title="BravoSUITE Blog - Online HR Management Software" />
      <NavigationHeader type="special" />
      <main id="news-home">
        <Banner />
        <Breadcrumb />
        <NewsGrid news={data?.allWpNew?.nodes} />
      </main>
      <Footer />
    </>
  );
}

News.propTypes = {
  data: propType.shape({
    allWpNew: propType.shape({
      nodes: propType.shape({})
    })
  }).isRequired
};

export default News;
